import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@components/header/header.component';
import { SidebarComponent } from '@components/sidebar/sidebar.component';
import { SecurityContextService } from '@services/security_context.service';
import { loading$ } from './interceptors/loading.interceptor';
import { datadogRum } from '@datadog/browser-rum';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, HeaderComponent, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less',
})
export class AppComponent implements OnInit, AfterViewInit {
  loading$: any;

  /**
   * used to show the full blur background on reload of logged in user
   * homer and metisMenu loads the styles too late and for ~1-2 sec user sees the menu without any styling
   * programmatically it is too complicated to catch the state and event when menu is fully rendered
   * hiding the component using Angular lifecycle hooks does not help
   */
  isFirstLoad = true;

  constructor(
    private _router: Router,
    public securityContextService: SecurityContextService,
  ) {}

  ngOnInit(): void {
    this.loading$ = loading$;

    if (!this.securityContextService.isLoggedIn()) {
      this._router.navigate(['/login']);
    }

    if (this.securityContextService.isLoggedIn()) {
      if (Object.keys(datadogRum?.getUser() ?? {}).length == 0) {
        const authData = this.securityContextService.authData();
        datadogRum?.setUser({
          id: authData.id,
          account_id: authData.accountid,
          name: authData.firstname + ' ' + authData.lastname,
          franchise_code: authData.franchisecode,
          account_type: authData.accounttype,
          username: authData.username,
          account_user_id: authData.accountuserid,
        });
      }
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isFirstLoad = false;
    }, 1000);
  }
}
